import React, {ReactNode} from "react";

export interface PageHeadingProps {
    title: ReactNode;
    element: ReactNode;
}

export default function TopBarElementTitle(props: PageHeadingProps) {
    return (
        <div className="top-bar-title top-bar-element-title">
            <h1>{props.title}</h1>
            {props.element}
        </div>
    );
}
